<div class="subindusties">
  <h6 translationEditableDirective="SUB_INDUSTRIES">
    {{ 'LICENSE_SUBCATEGORY_SLOTS' | translate }}
  </h6>
  <form-row
    (onDelete)="handleRowDelete(i)"
    [inline]="true"
    *ngFor="let slot of slots; let i = index"
  >
    <div class="field is-narrow">
      <label class="label is-small" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event, i)"
          [value]="slot.name"
          [ngClass]="{ 'is-danger': getError(i, 'name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="getError(i, 'name')">
        {{ getError(i, 'name') }}
      </p>
    </div>
    <div class="field is-narrow">
      <label
        class="label is-small"
        translationEditableDirective="CALCULATION_TYPE"
        >{{ 'CALCULATION_TYPE' | translate }}</label
      >
      <div class="control">
        <select
          [translationEditableModalDirective]="calculationTypesTranslateKeys"
          [translationEditableModalDirectiveDefaults]="
            calculationTypesTranslateDefaults
          "
          name="calculationType"
          class="input is-small"
          [ngClass]="{ 'is-danger': getError(i, 'calculationType') }"
          (change)="handleFieldChange($event, i)"
        >
          <option value="">{{ 'CALCULATION_TYPE' | translate }}</option>
          <option
            [selected]="slot.calculationType === type.name"
            *ngFor="let type of calculationTypes"
            [value]="type.name"
          >
            {{ type.trnKey | translate: { defaultValue: type.defaultName } }}
          </option>
        </select>
      </div>
      <p class="help is-danger" *ngIf="getError(i, 'calculationType')">
        {{ getError(i, 'calculationType') }}
      </p>
    </div>
    <div class="field is-narrow" *ngIf="slot.hasRange">
      <label
        class="label is-small"
        translationEditableDirective="RANGE_START"
        >{{ 'RANGE_START' | translate }}</label
      >
      <div class="control">
        <number-input
          name="rangeStart"
          step="0.1"
          (input)="handleFieldChange($event, i)"
          [value]="slot.rangeStart"
          [inputClass]="{
            'input is-small': true,
            'is-danger': getError(i, 'rangeStart'),
          }"
        />
      </div>
      <p class="help is-danger" *ngIf="getError(i, 'rangeStart')">
        {{ getError(i, 'rangeStart') }}
      </p>
    </div>
    <div class="field is-narrow" *ngIf="slot.hasRange">
      <label class="label is-small" translationEditableDirective="RANGE_END">{{
        'RANGE_END' | translate
      }}</label>
      <div class="control">
        <number-input
          name="rangeEnd"
          step="0.1"
          (input)="handleFieldChange($event, i)"
          [value]="slot.rangeEnd"
          [inputClass]="{
            'is-danger': getError(i, 'rangeEnd'),
            'input is-small': true,
          }"
        />
      </div>
      <p class="help is-danger" *ngIf="getError(i, 'rangeEnd')">
        {{ getError(i, 'rangeEnd') }}
      </p>
    </div>
    <div class="field is-narrow">
      <label class="label is-small" translationEditableDirective="SLOT_VALUE">{{
        'SLOT_VALUE' | translate
      }}</label>
      <div
        class="control"
        style="
          display: flex;
          align-items: center;
          margin: 0;
          padding: 0;
          margin-right: 5px;
        "
      >
        <number-input
          name="value"
          step="1"
          (input)="handleFieldChange($event, i)"
          [value]="slot.value"
          [inputClass]="{
            'is-danger': getError(i, 'value'),
            'input is-small': true,
          }"
        />
        <span
          class="is-size-6 ml-2"
          *ngIf="slot.calculationType === 'PROGRESSIVE'"
          >%</span
        >
        <span
          class="is-size-6 ml-2"
          *ngIf="slot.calculationType?.startsWith('FIXED')"
          >{{ settings.SETTINGS_UNITS_CURRENCY_SYMBOL }}</span
        >
      </div>
      <p class="help is-danger" *ngIf="getError(i, 'value')">
        {{ getError(i, 'value') }}
      </p>
    </div>
  </form-row>
  <div style="margin-bottom: 20px">
    <button
      type="button"
      (click)="handleRowAdd()"
      class="button is-small is-info"
      translationEditableDirective="ADD_LICENSE_SUBCATEGORY_SLOT"
    >
      {{ 'ADD_LICENSE_SUBCATEGORY_SLOT' | translate }}
    </button>
  </div>
</div>
